import React from 'react'
import { SlideShowL } from '../components/ChallengingRecords/SlideShowL/SlideShowL'
import { SlideShowM } from '../components/ChallengingRecords/SlideShowM/SlideShowM'
import { WhyChallenge } from '../components/ChallengingRecords/Why'
import { Testimonial } from '../components/Home/Testimonials/Testimonial'

const ChallengingRecords = () => {
  return (
    <>

    <SlideShowL/>
    <SlideShowM/>
    <WhyChallenge/>
    <Testimonial/>
    </>
  )
}

export default ChallengingRecords